// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a12396cf","977":"258c1783"}[chunkId] + ".chunk.js";
};